export const getErrorMessage = (error: unknown) =>
  error instanceof Error ? error.toString() : JSON.stringify(error);
